import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

export const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export const LoginSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
};
export const ProductListSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 5, 
  slidesToScroll: 1, 
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        arrows: false,
      }
    }
  ]
};


export const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
  }
};

export const getErrorMessage = (error: unknown): string => {
  if (!error) return "Something went wrong!";

  if (typeof error === "string") return error; 

  if (typeof error === "object" && error !== null) {
      const typedError = error as Record<string, any>;

      if ("data" in typedError && typeof typedError.data === "object") {
          return typedError.data?.message || "Something went wrong!";
      }

      if ("message" in typedError) {
          return String(typedError.message); 
      }
  }

  return "Unexpected error occurred!";
};


export const isExpired = (expiryDateString: string): boolean => {
  const formattedExpiryDateString = expiryDateString.replace(
      /^(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2} [APMapm]{2})$/,
      "$2-$1-$3 $4"
  );

  const expiryDate = new Date(formattedExpiryDateString);
  const currentDate = new Date();
  return expiryDate <= currentDate;
};

export function formatDate(inputDate: string): string {
  const dateParts = inputDate.split(" ");
  const dateStr = dateParts[0];
  const timeStr = dateParts[1] + " " + dateParts[2];

  const [day, month, year] = dateStr.split("-");

  const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
  ];

  const formattedDate = `${parseInt(day)} ${months[parseInt(month) - 1]}. ${parseInt(year)} ${timeStr}`;
  return formattedDate;
}


export const slugify = (str: string) => {
  return str
      .toLowerCase()
      .replace(/[^\w\s-]/g, '') 
      .trim()
      .replace(/\s+/g, '-');
};
